<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  // console.log(listData)

  const option= {
    grid: {
      left: '5%',
      top: '20%',
      right: '8%',
      bottom: '5%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    xAxis: {
      data:listData.time,
      type: 'category',
      boundaryGap: false,
      itemStyle: {
        borderColor: 'blue',
        color: '#ffffff'
      },
      axisLabel: {
        textStyle: {
          show: true,
          fontFamily: '微软雅黑',
          // color: '#5DCFF6',
          color: '#fff',

          fontSize: 14
        }
      }
    },
    yAxis: {
      name: '%',
      splitNumber: 2,
      nameTextStyle: {
        color:"#fff",
        fontSize:14
      },
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          // type: 'dashed'
          color:'rgba(255,255,255,0.2)'
        }
      },
      axisLabel: {
        textStyle: {
          show: true,
          fontFamily: '微软雅黑',
          // color: '#5DCFF6',
          color: '#fff',

          fontSize: 14
        }
      },
    },
    series: [{
      data:listData.value,
      name: '',
      type: 'line',
      // symbol: 'circle',
      symbol: 'emptyCircle',
      smooth: true,
      symbolSize: 7,
      lineStyle: {
        width: 1,
        type: 'solid'
      },
      label:{
        show:true,
        textStyle:{
          color:"#fff"
        }
      },
      itemStyle: {
        borderWidth: 1,
        borderColor: '#5BFCF4',
        color: '#5BFCF4'
      },
      areaStyle: {
        color: '#5BFCF4',
        normal: {
          //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [{
              offset: 0,
              color: 'RGBA(91, 252, 244, 0.3)'
              // color: '#019F75'
            },
              {
                offset: 0.5,
                color: 'RGBA(91, 252, 244, 0.2)'
                // color: '#3E483A'
              },
              {
                offset: 1,
                // color: '#0D152F'
                color: 'RGBA(91, 252, 244, 0)'
              }
            ],
            false
          ),
          shadowBlur: 0 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
        }
      }
    }]
  };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option, true);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
